import React from 'react';
import {getCheckNiudStatusErrorMessage, CHECK_NIUD_STATUS_TYPES} from '../constants';

const CheckNiudStatusResultMessage = ({
  apiError,
  apiErrorMessage,
  statusType,
  statusMessage,
  requestedPortTime,
  formattedPortTime,
}) => {
  if (apiError) {
    return (
      <div className='check-niud-status-message check-niud-status-message--error'>
        <p>{getCheckNiudStatusErrorMessage(apiErrorMessage)}</p>
      </div>
    );
  }

  if (statusType === CHECK_NIUD_STATUS_TYPES.NiudTime) {
    const portTimeDisplay = formattedPortTime || requestedPortTime;
    if (portTimeDisplay) {
      return (
        <div className='check-niud-status-message check-niud-status-message--success'>
          <p className='check-niud-status-message__subtitle'>זמן הניוד המבוקש: {portTimeDisplay}</p>
        </div>
      );
    }
  }

  if (statusMessage) {
    return (
      <div className='check-niud-status-message check-niud-status-message--success'>
        <p className='check-niud-status-message__title'>{statusMessage}</p>
      </div>
    );
  }

  return null;
};

export default CheckNiudStatusResultMessage;
